<template>
  <div class="contenedor">
    <div v-if="loading">
      <div class="card-body card-separador">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <CarouselBanners />
      <CarouselCategorias />

      <LocationModal ref="locationModal" />

      <ModalInfoBeneficio
        ref="modal"
        :esUsuario="EsAfiliado"
        :service="Service"
        @close="modalBeneficioClosed"
        v-on:suscribiendo="suscribiendoABeneficio"
      />

      <!-- Subcategorías y tarjetas -->
      <div class="subcategorias-tarjetas">
        <!-- Sub-categorías !-->
        <div class="subcategorias">
          <h5 v-for="sub in subcategorias" v-bind:key="sub.id">
            <a v-on:click="seleccionarSubCategoria(sub)">
              {{ sub.name }}
            </a>
          </h5>
        </div>
        <div class="tarjetas">
          <h2 class="titulo-beneficios">
            <span v-if="location">Beneficios en</span>
            <button
              type="button"
              class="btn btn-link boton-ciudad"
              @click="clickCambiarLocalidad()"
            >
              <span v-if="location" class="nombre-ciudad">
                {{ CurrentLocationString }}</span
              >
              <span v-else class="nombre-ciudad"> Todas las localidades </span>
              <font-awesome-icon class="icono-derecha" :icon="Icons.EDITAR" />
            </button>
          </h2>
          <TarjetasBeneficio
            ref="tarjetas"
            :infoSinResultados="'Prueba cambiar la categoría o la ciudad'"
            :location="location"
            :service="Service"
            :subcategoria="subcategoria"
            @click-beneficio="openModalBeneficio"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapState } from "vuex";

import { Api } from "../../api";
import { BeneficioAfiliadoService } from "../../servicios/cliente/afiliado/beneficio.afiliado.service";
import { BeneficioVisitaService } from "../../servicios/cliente/visita/beneficio.visita.service";
import CarouselBanners from "../../components/CarouselBanners";
import CarouselCategorias from "../../components/CarouselCategorias";
import { Icons as IconConstants } from "../../constants";
import LocationModal from "../../components/cliente/LocationModal";
import ModalInfoBeneficio from "../../components/cliente/ModalInfoBeneficio";
import TarjetasBeneficio from "../../components/TarjetasBeneficio";

export default {
  components: {
    FontAwesomeIcon,

    CarouselBanners,
    CarouselCategorias,
    LocationModal,
    ModalInfoBeneficio,
    TarjetasBeneficio,
  },
  data() {
    return {
      idUsuario: null,
      loading: true,
      modalVisible: false,
      nombreUsuario: "",
      subcategorias: [],
      token: "",
    };
  },
  computed: {
    EsAfiliado() {
      return this.idUsuario != null && this.token != null;
    },
    Icons() {
      return IconConstants;
    },
    CurrentLocationString() {
      if (this.location) {
        if (this.location.city) {
          return this.location.city.nombre;
        } else if (this.location.province) {
          return this.location.province.nombre;
        }
      }
      return "";
    },
    Service() {
      return this.EsAfiliado
        ? BeneficioAfiliadoService
        : BeneficioVisitaService;
    },
    // Computed properties de vuex
    // Datos compartidos en toda la app
    ...mapState({
      categoria: (state) => state.categoria,
      location: (state) => state.location,
      subcategoria: (state) => state.subcategoria,
    }),
  },
  watch: {
    categoria(nueva) {
      this.subcategorias = [];
      this.$store.commit("limpiarSubcategoria");

      if (nueva && nueva.id) {
        // Cargar subcategorias
        Api.Categoria.getSubcategoriasDeCategoria(nueva.id).then((response) => {
          this.subcategorias = response.data;

          if (this.subcategorias != null && this.subcategorias.length > 0) {
            this.seleccionarSubCategoria(this.subcategorias[0]);
          }
        });
      }
    },
  },
  methods: {
    abrirModal() {
      this.modalVisible = true;
    },
    cerrarModal() {
      this.modalVisible = false;
    },
    openModalBeneficio(beneficio) {
      this.$refs.modal.abrir(beneficio.id, beneficio.suscripto);
    },
    modalBeneficioClosed() {},
    clickCambiarLocalidad() {
      // Acá se abre el modal
      this.$refs.locationModal.EventoAbrir();
    },
    /**Seleccionar sub categoria y cargar beneficios */
    seleccionarSubCategoria(subcategoria) {
      if (!this.subcategoria || subcategoria.id != this.subcategoria.id)
        this.$store.commit("cambiarSubcategoria", subcategoria);
    },
    // Cuando usuario se suscribe a un beneficio
    // Se recibe {promesa, beneficio}, la promesa es la petición de suscripción
    // Al server, cuando esta se cumpla significa que se suscribió correctamente
    suscribiendoABeneficio(promesaYBeneficio) {
      promesaYBeneficio.promesa.then(() => {
        this.suscriptoABeneficio(promesaYBeneficio.beneficio.id);
      });
    },
    /**Eliminar un beneficio de la lista cuando se suscribe al beneficio */
    suscriptoABeneficio(beneficioId) {
      this.$store.commit("beneficioUpdate", {
        beneficioId,
        data: { suscripto: true },
      });
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.nombreUsuario = localStorage.getItem("user");
    this.idUsuario = localStorage.getItem("iduser");

    this.loading = false;
  },
};
</script>

<style scoped>
.contenedor {
  padding-bottom: 15px;
}

.subcategorias-tarjetas {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}
.subcategorias-tarjetas > * {
  flex-grow: 1;
}

.subcategorias {
  border-top: 1px solid;
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 1000;
}
.subcategorias div {
  text-align: left;
}
.subcategorias h5,
.subcategorias h5 a {
  font-size: 16px;
  overflow-wrap: normal;
  cursor: pointer;
  width: 150px;
  position: relative;
  right: 2px;
}
.subcategorias h5 {
  border-left: 2px solid #2c3e50;
}
.subcategorias h5 a:hover {
  padding: 2px 20px 2px 20px;
  background: var(--color-estructura-c);
  font-weight: bold;
  transition-duration: 0.2s;
  transition-timing-function: ease;
  line-height: 1.8;
}

.titulo-beneficios {
  text-align: left;
  font-size: 20px;
  color: var(--color-estructura-a);
  margin-left: 10px;
}
.titulo-beneficios span {
  margin-right: 10px;
}

.titulo-beneficios,
.boton-ciudad {
  padding: 0;
  height: 30px;
  padding-left: 4px;
  color: var(--color-estructura-a);
  text-decoration: none;
}

.boton-ciudad {
  min-width: 200px;
  padding: 0 10px;
  font-size: 18px;
  background-color: transparent;
  color: var(--color-estructura-c);
  border-radius: 4px;
  position: relative;
  transition: all 1s;
  background-color: var(--color-estructura-a);
}

.boton-ciudad::after {
  content: "Elija Localidad";
  height: 30px;
  color: transparent;
  left: -70px;
  top: 0;
  bottom: 0;
  right: 0;
  transition: all 1s;
  position: absolute;
}

.boton-ciudad::before {
  content: "";
  width: auto;
  height: 30px;
  left: -200px;
  top: 0;
  bottom: 0;
  right: 0;
  transition: all 2s;
  position: absolute;
  color: transparent;
}

.boton-ciudad:hover:after {
  left: 0px;
  color: var(--color-estructura-c);
}

.boton-ciudad:hover:before {
  width: 200px;
  color: transparent;
}

.boton-ciudad:hover {
  right: 0px;
  color: transparent;
}

@media (min-width: 0px) and (max-width: 675px) {
  .subcategorias h5 {
    margin-top: 7px;
  }

  .titulo-beneficios {
    height: 60px !important;
    font-size: 14px;
  }

  .titulo-beneficios {
    margin-left: 0;
  }
  .titulo-beneficios span {
    margin-right: 0;
  }

  .titulo-beneficios,
  .boton-ciudad {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }

  .boton-ciudad {
    min-width: 100px;
    font-size: 12px;
    height: 60px;
  }

  .icono-derecha {
    /* display: none; */
    font-size: 11px;
  }
}

@media (min-width: 576px) {
  .subcategorias-tarjetas {
    flex-direction: row;
  }

  .subcategorias {
    max-width: 200px;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 10px;
  }
}
</style>
